
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, type, className = '', ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className="w-full space-y-3">
      {label && (
        <label className="text-[10px] font-black text-brand-muted uppercase tracking-[0.3em] ml-2 flex items-center gap-2">
          {label}
        </label>
      )}
      <div className="relative group">
        <input
          type={inputType}
          className={`
            w-full bg-white/5 border border-white/10 rounded-[1.5rem] px-7 py-5 text-sm text-white
            focus:outline-none focus:border-brand-primary focus:ring-8 focus:ring-brand-primary/5
            focus:bg-brand-primary/[0.02]
            transition-all duration-500 placeholder:text-brand-muted/40 font-bold
            ${isPassword ? 'pr-14' : ''}
            ${error ? 'border-red-500/50 focus:border-red-500 focus:ring-red-500/5' : ''}
            ${className}
          `}
          {...props}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-6 top-1/2 -translate-y-1/2 text-brand-muted hover:text-brand-primary transition-colors duration-300 z-10 p-1"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}

        {/* Subtle radial glow on focus */}
        <div className="absolute inset-0 rounded-[1.5rem] bg-brand-primary/10 blur-[20px] opacity-0 group-focus-within:opacity-30 transition-opacity pointer-events-none"></div>
      </div>
      {error && <p className="text-[10px] text-red-400 font-black uppercase tracking-widest ml-2 animate-in slide-in-from-left-2">{error}</p>}
    </div>
  );
};

export default Input;
